import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export function HelpSearch() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="relative">
      <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Søk i hjelp og dokumentasjon..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}